interface ArrowDownIconProps {
  color?: string;
  className?: string;
}

const ArrowDownIcon = ({ color = "currentColor", className }: ArrowDownIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      className={className}
    >
      <path
        d="M13.0248 1.02483L7.02483 7.02483C6.96911 7.08062 6.90294 7.12488 6.8301 7.15507C6.75726 7.18526 6.67918 7.2008 6.60033 7.2008C6.52148 7.2008 6.44341 7.18526 6.37057 7.15507C6.29773 7.12488 6.23156 7.08062 6.17583 7.02483L0.175834 1.02483C0.0632492 0.912249 0 0.759552 0 0.600334C0 0.441115 0.0632492 0.288418 0.175834 0.175833C0.288418 0.0632489 0.441115 0 0.600334 0C0.759552 0 0.912249 0.0632489 1.02483 0.175833L6.60033 5.75208L12.1758 0.175833C12.2316 0.120087 12.2978 0.075867 12.3706 0.0456974C12.4434 0.0155278 12.5215 0 12.6003 0C12.6792 0 12.7572 0.0155278 12.8301 0.0456974C12.9029 0.075867 12.9691 0.120087 13.0248 0.175833C13.0806 0.231579 13.1248 0.29776 13.155 0.370596C13.1851 0.443432 13.2007 0.521497 13.2007 0.600334C13.2007 0.67917 13.1851 0.757236 13.155 0.830071C13.1248 0.902907 13.0806 0.969088 13.0248 1.02483Z"
        fill={color}
      />
      <path
        d="M13.0248 1.02483L7.02483 7.02483C6.96911 7.08062 6.90294 7.12488 6.8301 7.15507C6.75726 7.18526 6.67918 7.2008 6.60033 7.2008C6.52148 7.2008 6.44341 7.18526 6.37057 7.15507C6.29773 7.12488 6.23156 7.08062 6.17583 7.02483L0.175834 1.02483C0.0632492 0.912249 0 0.759552 0 0.600334C0 0.441115 0.0632492 0.288418 0.175834 0.175833C0.288418 0.0632489 0.441115 0 0.600334 0C0.759552 0 0.912249 0.0632489 1.02483 0.175833L6.60033 5.75208L12.1758 0.175833C12.2316 0.120087 12.2978 0.075867 12.3706 0.0456974C12.4434 0.0155278 12.5215 0 12.6003 0C12.6792 0 12.7572 0.0155278 12.8301 0.0456974C12.9029 0.075867 12.9691 0.120087 13.0248 0.175833C13.0806 0.231579 13.1248 0.29776 13.155 0.370596C13.1851 0.443432 13.2007 0.521497 13.2007 0.600334C13.2007 0.67917 13.1851 0.757236 13.155 0.830071C13.1248 0.902907 13.0806 0.969088 13.0248 1.02483Z"
        fill="white"
        fillOpacity="0.3"
      />
    </svg>
  );
};

export default ArrowDownIcon;
